import React from 'react';
import './FilterChips.css';

function FilterChips({
  options,
  value,
  onChange,
  ariaLabel = 'Filter options',
  className = '',
}) {
  return (
    <div className={`filter-chips ${className}`.trim()} aria-label={ariaLabel}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          className={`filter-chip ${value === option.key ? 'active' : ''}`}
          onClick={() => onChange(option.key)}
        >
          <span>{option.label}</span>
          {typeof option.count === 'number' && <span className="chip-count">{option.count}</span>}
        </button>
      ))}
    </div>
  );
}

export default FilterChips;
